import React from "react";
import Styles from "../Home/AboutMe.module.css";
import LatestPostHeader from "../Home/LatestPostHeader";
import styles from "../Home/LatestPosts.module.css";
import BLOG_POSTS from "../BlogPostData/BlogPosts";
import Postitem from "../Home/PostItem";

const Writings = () => {
  const blogPost = BLOG_POSTS.map((post) => (
    <Postitem
      key={post.id}
      title={post.title}
      date={post.date}
      image={post.image}
      url={post.link}
    />
  ));
  return (
    <div
      className={Styles.Main}
      style={{ flexDirection: "column", paddingLeft: 0 }}
    >
      <LatestPostHeader
        demo={""}
        margin={"marginLeft:0"}
        title="Latest Posts"
      />
      <div>
        <section>
          <ul className={styles.grid} style={{ paddingBottom: 200 }}>
            {blogPost}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Writings;
